// 各种图层类型默认值
export default {
    WMS: {
        type: 'WMS',
        name: '',
        url: '',
        version: '1.1.1',
        format: '',
        formats: '',
        epsg: '',
        visibility: true,
        opacity: 1,
        maxExtent: '',
        metadata: '',
        minZoom: 1,
        maxZoom: 24
    },
    WMTS: {
        type: 'WMTS',
        name: '',
        url: '',
        version: '1.0.0',
        styles: '',
        style: 'default',
        zoomOffset: 0,
        matrixSet: '',
        matrixIds: '',
        format: '',
        formats: '',
        visibility: true,
        opacity: 1,
        maxExtent: '',
        metadata: '',
        minZoom: 1,
        maxZoom: 24
    },
    VWMTS: {
        type: 'VWMTS',
        name: '',
        url: '',
        times: '',
        time: '',
        userecent: false,
        version: '1.0.0',
        styles: '',
        style: 'default',
        zoomOffset: 0,
        matrixSet: '',
        matrixIds: '',
        format: '',
        formats: '',
        visibility: true,
        opacity: 1,
        maxExtent: '',
        metadata: '',
        minZoom: 1,
        maxZoom: 24
    },
    VTS: {
        type: 'VTS',
        name: '',
        url: '',
        version: '1.0.0',
        styles: '',
        style: 'default',
        zoomOffset: 0,
        matrixSet: '',
        matrixIds: '',
        format: 'protobuf',
        formats: '',
        visibility: true,
        opacity: 1,
        maxExtent: '',
        metadata: '',
        minZoom: 1,
        maxZoom: 24
    },
    VVTS: {
        type: 'VVTS',
        name: '',
        url: '',
        times: '',
        time: '',
        userecent: false,
        version: '1.0.0',
        styles: '',
        style: 'default',
        zoomOffset: 0,
        matrixSet: '',
        matrixIds: '',
        format: 'protobuf',
        formats: '',
        visibility: true,
        opacity: 1,
        maxExtent: '',
        metadata: '',
        minZoom: 1,
        maxZoom: 24
    },
    TILE: {
        type: 'TILE',
        name: '',
        url: '',
        version: '',
        format: '',
        formats: '',
        visibility: true,
        opacity: 1,
        maxExtent: '',
        metadata: '',
        minZoom: 1,
        maxZoom: 24
    },
    TMS: {
        type: 'TMS',
        name: '',
        url: '',
        version: '',
        layerId: '',
        chartId: '',
        format: 'png',
        visibility: true,
        opacity: 1,
        maxExtent: '',
        hasLegend: true,
        hasBaseMap: true,
        metadata: '',
        minZoom: 1,
        maxZoom: 24
    },
    ODMS: {
        type: 'ODMS',
        name: '',
        url: '',
        version: '1.0.0',
        layerId: '',
        chartId: '',
        visibility: true,
        opacity: 1,
        maxExtent: '',
        metadata: '',
        minZoom: 1,
        maxZoom: 24
    },
    DQS: {
        type: 'DQS',
        name: '',
        url: '',
        version: '1.0.0',
        metadata: '',
        minZoom: 1,
        maxZoom: 24
    },
    TERRAIN: {
        type: 'TERRAIN',
        name: '',
        url: '',
        version: '',
        format: '',
        formats: '',
        dataType: '',
        visibility: true,
        opacity: 1,
        maxExtent: '',
        minZoom: 1,
        maxZoom: 24
    },
    MODELCESIUM: {
        type: 'MODELCESIUM',
        name: '',
        url: '',
        version: '',
        visibility: true,
        opacity: 1
    },
    WTFS: {
        type: 'WTFS',
        name: '',
        url: '',
        version: '',
        format: '',
        visibility: true,
        opacity: 1,
        maxExtent: '',
        minZoom: 1,
        maxZoom: 24
    }
}
